<template>
  <div>
    <v-row dense>
      <v-col cols="12" md="6">
        <v-list dense>
          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Driver Name</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">{{ casefile.insuredDriverName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-card-account-details</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>NRIC</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">{{ casefile.insuredDriverIc }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>

      <v-col cols="12" md="6">
        <v-list dense>
          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-phone</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Tel</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">{{ casefile.insuredDriverTel }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-icon><v-icon>mdi-email</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-subtitle>Email</v-list-item-subtitle>
              <v-list-item-title class="font-weight-medium">{{ casefile.insuredDriverEmail }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'InsuredDriverDetailsBody',
  props: ['casefile']
}
</script>
